import "react-quill-new/dist/quill.snow.css";
import { useState} from "react"

import { Alert } from "antd";
import PaymentTabel from "./PaymentTable";

const OrderASOEdit = () => {
  const [success, setSuccess] = useState(false);

  return (
    <div className={`wrapper`}>
      {success && (
        <Alert
          message="Saved!"
          type="success"
          showIcon
          closable
          onClose={() => setSuccess(false)}
        />
      )}

      <div className={`page page-app`}>
        <h2>Payment Calendar</h2>
        <PaymentTabel></PaymentTabel>
      </div>
    </div>
  );
};

export default OrderASOEdit;
